<template>
<v-expansion-panels>
   <v-subheader><h3>Administración de BlackOut</h3></v-subheader>

    <v-expansion-panel>
      <v-expansion-panel-header>BlackOut</v-expansion-panel-header>
      <v-expansion-panel-content>
        <BlackOutGrid/>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel>
      <v-expansion-panel-header>Usuario por Proveedor</v-expansion-panel-header>
      <v-expansion-panel-content>
        <UserMotherSupplierGrid/>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel>
      <v-expansion-panel-header>Usuario por Centro</v-expansion-panel-header>
      <v-expansion-panel-content>
        <UserOpPointGrid/>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel>
      <v-expansion-panel-header>Timeout Turnado</v-expansion-panel-header>
      <v-expansion-panel-content>
        <TimeoutGrid/>
      </v-expansion-panel-content>
    </v-expansion-panel>

  </v-expansion-panels>
</template>

<script>
import BlackOutGrid from './BlackOutGrid'
import UserMotherSupplierGrid from './UserMotherSupplierGrid'
import UserOpPointGrid from './UserOpPointGrid'
import TimeoutGrid from './TimeoutGrid'

export default {
  components: {
    BlackOutGrid,
    UserMotherSupplierGrid,
    UserOpPointGrid,
    TimeoutGrid
  },
  created () {
    this.$store.commit('updateTitle', 'Panel de Administración de Turnado')
  }
}
</script>


// WEBPACK FOOTER //
// src/components/AdministrationTurnado.vue